<template lang="pug">
img(:src="path")
</template>
<script>
export default {
  props: {
    file: null,
  },
  data() {
    return {
      preview: null,
    };
  },
  computed: {
    path() {
      if (this.preview) {
        return this.preview;
      } else {
        return null;
      }
    },
  },
  watch: {
    file(file) {
      this.getPreview(file);
    },
  },
  mounted() {
    this.getPreview(this.file);
  },
  methods: {
    getPreview(file) {
      let reader = new FileReader();
      new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(file);
      }).then((result) => {
        this.preview = result;
      });
    },
  },
};
</script>
